import styled from "styled-components";

export const CardContainer = styled.aside`
    ${
        props => props.qtdCards >= 3 ?
            `width: calc((100%/3) - 3%);`
        :
            `width: 30%;`
    }
    height: 225px;
    margin-top: 25px;

    position: relative;
    cursor: pointer;
    
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    a{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 999;
    }

    .rect{
        width: 100%;
        height: 100%;
        border-radius: 20px;

        position: absolute;
        z-index: -2;

        transition: all ease-in-out .5s;
        background: ${props => props.bgColor};
    }

    img{
        width: 75%;
        position: absolute;
        top: -50%;
    }

    h3{
        font: 1rem/1 'Titan One',arial,sans-serif;
        color: ${props => props.txtColor};
        margin-bottom: 15%;
    }

    &:first-child{
        margin-top: 0;
        margin-top: 25px;
        img{
            top: -50%;
        }
    }

    &:nth-child(2){
        margin: 0 2%;
        margin-top: 25px;
        img{
            width: 85%;
        }
    }

    &:hover{
        .rect{
            transform: scaleY(1.1);
            transform-origin: bottom;
        }
    }

    @media screen and (max-width: 480px) {
        width: 65%;   
        height: 175px;

        img{
            width: 45%;
        }

        &:first-child{
            height: 175px;
        }


        &:nth-child(2){
            margin: 25% 0;
            img{
                width: 45%;
            }
        }
    }

    
`;